<template>

  
        <DBox
            :id="'cmp-catalog-product-sidewindow-country-restriction'"
            :addButton="false"
            :addLink="true"
            :addLinkLabel="$t('add_new') + ' ' + $t('country')"
            :rightMenu=" [
              {
                text: $t('invert_countries'),
                value: 'invert',
              },
              {
                text: $t('remove_countries'),
                value: 'remove',
              },
            ]"
            @menuClick="onMenuClick"
            @add_click="onAddRestrictedCountry"
        >
      
            <div class="flex-container ut-fh">
                <!-- <DList
                    :items="selectedProductDetails.countries"
                    :primaryKey="'country_relation_id'"
                    :labelKey="'country_fullname'"
                    :clickable="true"
                    @delete="ongroupDelete"
                    @item_click="onGroupClick"
                  >
                  </DList>
                  <DList
                    :items="selectedProductDetails.countries_allowed"
                    :primaryKey="'product_group_id'"
                    :labelKey="'country_fullname'"
                    :clickable="true"
                    @delete="ongroupDelete"
                    @item_click="onGroupClick"
                  >
                  </DList> -->
              <NTable
                id="catalog-product-special"
                 :showNoItems="false"
                :config="tableConfig"
                :headers="Headers"
                :items="countries"
        
            
              >
                <template v-slot:item="{ item, tdcon }">
                    <tr
                      
                    >
                        <td v-bind="tdcon('country_restriction')">
                            <span>{{item['country_fullname']}}</span>
                        </td>
                        <td v-bind="tdcon('option')">
                            <div class="dt-icon-container">
                              <img
                                @click.stop="(e) => deleteCountry(item)"
                                src="static/icons/delete.svg"
                                class="dt-icon v5 s2"
                              />
                            </div>
                        </td>
                    
                        
                    </tr>
                </template>
              </NTable>
              <NTable
                class="dbox1"
                id="catalog-releases-related-manual_matches"
                :showNoItems="false"
                :config="tableConfig"
                :headers="Headers2"
                :items="countryallowed"
             
              >
                <template v-slot:item="{ item, tdcon }">
                    <tr
                      
                    >
                        <td v-bind="tdcon('country_allowed')">
                            <span>{{item['country_fullname']}}</span>
                        </td>
                     
                    
                        
                    </tr>
                </template>
              </NTable>
            </div>
        </DBox>
  
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from '../../../../plugins/datatable';
import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    selectedProductDetails: {
        type: Object,
    },

  },
  components: {
        NTable,
        DBox,
        DList
   
  },
  data: function() {
    return {
        tableConfig: createNTableConfig({
        headerStyle: 3,
         fullHeight: true,
      }),
    };
  },
  computed:{
   
        Headers: function () {
            return [
                createTableHeader("country_restrictions", { }),
                createTableHeader("option",{ text:false ,mw:30})
              ];
        },
        Headers2: function () {
            return [
                createTableHeader("country_allowed", { }),
                createTableHeader("option",{ text:false ,mw:30})
              ];
        },

        countries:function(){
            return this.selectedProductDetails.countries||[]
        },
        countryallowed:function(){
           return this.selectedProductDetails.countries_allowed||[]
        }
  

  },
  methods:{
    onAddRestrictedCountry:function(){
                this.$router.push({
        ...this.$route,
        query: {
          modal: "add_country_restrict",
          external_id:this.selectedProductDetails.product.product_id
        },
      });
    },
    
    deleteCountry:function(item){
   
      this.$emit("delete",item)
    },

    onMenuClick:function(payload){
          console.log("PAYLOAD",payload);

      switch(payload) 
      {
            case "invert":
              this.$emit("invert")
              break;
            case "remove":
              this.$emit("remove")
              break;
            default:
         
      }
    },
  }

}
</script>
<style lang="scss">
.cmp-catalog-product-sidewindow-country-restriction{
  
  .flex-container{
      display: flex;
      flex:1
  }
  .dt-ntable {
    //--ntable-height: 170px;
    .country_allowed:not(th){
      background: #64C8961F;
      //color: #000;
    }

    .country_restriction{
      background: #FF6E6E1F;
      //color: #000;
    }
    .option:not(th){
      background: #FF6E6E1F;
    }
  }

}
</style>
